import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { getApiUrl } from '../../../utils/apiConfig';


const TipoVisitaDropdown = ({ selectedVisita, setSelectedVisita }) => {
  const [tipoOptions, setTipoOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const fetchTipos = async () => {
      try {
        const res = await fetch(getApiUrl('/api/tipoVisita'));
        const data = await res.json();
        const options = data.map(item => ({
          id: item.IdTipoVisita, // ID real
          value: item.TipoVisita, // texto/etiqueta
          label: item.TipoVisita,
          color: '#eee',
        }));
        setTipoOptions(options);
      } catch (err) {
        console.error('Error al cargar tipos de visita:', err);
      }
    };

    fetchTipos();
  }, []);

  // const selected = tipoOptions.find(opt => opt.value === selectedVisita?.TipoVisita) || { value: '', label: '', color: '#eee' };

  
  const selected = {
    value: selectedVisita?.TipoVisita || '',
    label: selectedVisita?.TipoVisita || '',
    color: '#eee'
  };

  const placeholder = 'Selecciona tipo de visita';
  const hasSelection = Boolean(String(selectedVisita?.IdTipoVisita ?? '').trim());

  // Cerrar dropdown al hacer clic fuera
  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="relative w-full" ref={containerRef}>
      <label className="block mb-1 text-xs font-medium text-gray-700 truncate">Tipo de Visita*</label>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="DropDownName w-full p-2 shadow-sm border rounded bg-white flex justify-between items-center"
        aria-haspopup="listbox"
        aria-expanded={isOpen}
        title={hasSelection ? selected.label : placeholder}
      >
        <span className={`truncate ${hasSelection ? '' : 'text-gray-400'}`}>
          {hasSelection ? selected.label : placeholder}
        </span>
        <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      {isOpen && (
        <ul className="absolute mt-1 w-full bg-white border rounded shadow-lg max-h-60 overflow-auto"  style={{ zIndex: 1100 }} role="listbox">
          <li
            onClick={() => { setSelectedVisita({ ...selectedVisita, IdTipoVisita: '', TipoVisita: '' }); setIsOpen(false); }}
            className={`cursor-pointer px-4 py-2 text-sm hover:bg-blue-50 hover:text-blue-700 transition-colors ${!hasSelection ? 'bg-blue-50 text-blue-700 font-medium' : ''}`}
            role="option"
            aria-selected={!hasSelection}
          >
            {placeholder}
          </li>
          {tipoOptions.map(option => (
            <li
              key={option.id ?? option.value}
              onClick={() => {
                setSelectedVisita({ ...selectedVisita, IdTipoVisita: option.id, TipoVisita: option.label });
                setIsOpen(false);
              }}
              className={classNames(
                'cursor-pointer px-4 py-2 text-sm hover:bg-blue-50 hover:text-blue-700 transition-colors',
                { 'bg-blue-50 text-blue-700 font-medium': String(selectedVisita.IdTipoVisita ?? '').trim() === String(option.id) }
              )}
              role="option"
              aria-selected={String(selectedVisita.IdTipoVisita ?? '').trim() === String(option.id)}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default TipoVisitaDropdown;
